import { render, staticRenderFns } from "./ReportFormPersonalDataSimple.vue?vue&type=template&id=3e3e53fc"
import script from "./ReportFormPersonalDataSimple.vue?vue&type=script&lang=ts"
export * from "./ReportFormPersonalDataSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports